import React, { useState } from "react";
import ZeytinHesapWordPressMockup from "./ZeytinHesapWordPressMockup";
import Dashboard from "./Dashboard";

const AUTH_KEY = "zeytinhesap_auth";

export default function App() {
  const isPanelPage = window.location.pathname === "/panel";
  const [authState, setAuthState] = useState(() => {
    try {
      const raw = localStorage.getItem(AUTH_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  const handleLogin = ({ token, user }) => {
    const nextState = { token, user };
    setAuthState(nextState);
    localStorage.setItem(AUTH_KEY, JSON.stringify(nextState));
  };

  const handleLogout = () => {
    setAuthState(null);
    localStorage.removeItem(AUTH_KEY);
  };

  if (isPanelPage) {
    if (!authState?.token) {
      return <ZeytinHesapWordPressMockup initialPage="login" />;
    }

    return (
      <Dashboard
        sessionToken={authState.token}
        currentUser={authState.user || null}
        onSessionExpired={handleLogout}
      />
    );
  }

  return <ZeytinHesapWordPressMockup />;
}